import { Common, ApiBind } from './common.model';

/**
 * メンテナンス状態を表すモデルクラス
 * @remarks
 * メンテナンスの状態を管理し、APIとのデータバインドを行う。
 */
export class Maintenance extends Common {
  /**
   * メンテナンス状態
   *
   * - `1`: 通常稼働
   * - `2`: メンテナンス中
   */
  @ApiBind({ column: 'status' })
  status: number;

  @ApiBind({ column: 'updated_at', includeJSON: true, model: (value) => value  })
  updatedAt: string;
}
